<div class="modal-header">
  <h5 class="modal-title">{{'DOWNLOAD-LOGS.TITLE' | translate}}</h5>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.close('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body download-logs-box">
  <div *ngIf="loading" class="text-center p-y-40">
    <img src="../../../assets/images/loading-spinner.gif" height="80">
  </div>
  <div *ngIf="!loading && !totalItems" class="text-center p-y-40">
    <h5 class="m-0">{{'COMMON.DATA-NOT-FOUND' | translate}}</h5>
  </div>
  <ng-container *ngIf="!loading && totalItems">
    <app-custom-pagination
        [(currentPage)]="currentPage"
        [(itemsPerPage)]="itemsPerPage"
        [totalItems]="totalItems"
        (pageChange)="pageChanged()"
        (optionChange)="optionChanged()">
      <button class="btn btn-dv" (click)="loadCeleryResults()">
        {{'DOWNLOAD-LOGS.REFRESH' | translate}}
      </button>
    </app-custom-pagination>
    <div class="m-t-20">
      <p-table tableStyleClass="table" [value]="tableData" [autoLayout]="true">
        <ng-template pTemplate="header">
          <tr class="text-center">
            <th style="width: 2rem;">{{'COMMON.TABLE.ORDER' | translate}}</th>
            <th>{{'TABLE.CREATED-AT' | translate}}</th>
            <th>{{'TABLE.CREATED-USER' | translate}}</th>
            <th>{{'TABLE.FILTER' | translate}}</th>
            <th>{{'TABLE.STATE' | translate}}</th>
            <th>{{'TABLE.RESULT' | translate}}</th>
            <th>{{'TABLE.ACTION' | translate}}</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-data let-index="rowIndex">
          <tr class="text-center">
            <td>{{index + 1 + ((currentPage - 1) * itemsPerPage)}}</td>
            <td>{{data.created_at | date:'dd/MM/yyyy HH:mm'}}</td>
            <td>{{data.created_username}}</td>
            <td>
              <div class="pointer"
                  #pop="ngbPopover"
                  (clickOutside)="pop.close()"
                  container="body"
                  placement="left"
                  [ngbPopover]="popOver"
                  popoverTitle="{{'TABLE.DETAIL' | translate}}">
                <i class="fa fa-eye" aria-hidden="true"></i>
              </div>
              <ng-template #popOver>
                <ul class="mb-0 p-l-10" *ngIf="data.filter_params">
                  <li *ngFor="let res of data.filter_params;">{{res}}</li>
                </ul>
                <span *ngIf="!data.filter_params">-</span>
              </ng-template>
            </td>
            <td>
              <i class="fa fa-lg" [ngClass]="{
                  'fa-times-circle text-danger': data.state === 'FAILURE',
                  'fa-check-circle text-success': data.state === 'SUCCESS',
                  'fa-circle-notch fa-spin text-info': data.state === 'PENDING' || data.state === 'PROGRESS',
                  'fa-minus-circle text-secondary': data.state === 'REVOKED'
                }">
              </i>
            </td>
            <td>
              <ng-container *ngIf="data.state === 'FAILURE' || data.state === 'REVOKED'">
                <div class="pointer"
                    #pop="ngbPopover"
                    (clickOutside)="pop.close()"
                    container="body"
                    placement="left"
                    [ngbPopover]="popOverError"
                    popoverTitle="{{'TAX-B2P.ERROR' | translate}}">
                  <i class="fa fa-eye" aria-hidden="true"></i>
                </div>
                <ng-template #popOverError>
                  {{data.error}}
                </ng-template>
              </ng-container>
              <i *ngIf="data.state === 'SUCCESS'"
                  class="fa fa-download fa-lg download-icon pointer"
                  aria-hidden="true"
                  (click)="downloadFile(data)">
              </i>
              <span *ngIf="data.state === 'PENDING' || data.state === 'PROGRESS'">-</span>
            </td>
            <td>
              <i class="fa fa-lg fa-trash text-danger pointer" (click)="openConfirmModal(confirmContentModal, data, 'delete')" *ngIf="data.state !== 'PENDING' && data.state !== 'PROGRESS'"></i>
              <i class="fa fa-lg fa-times text-danger pointer" (click)="openConfirmModal(confirmContentModal, data, 'cancel')" *ngIf="data.state === 'PENDING' || data.state === 'PROGRESS'"></i>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </ng-container>
</div>
<div class="modal-footer">
  <button class="btn btn-dv btn-clean" (click)="activeModal.close('Cross click')">
    <i class="fa fa-times"></i>
    {{'COMMON.CLOSE' | translate}}
  </button>
</div>

<ng-template #confirmContentModal>
  <div class="modal-header">
    <h5 class="modal-title"></h5>
    <button type="button" class="close" aria-label="Close" (click)="modal.close()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body text-center p-y-40">
    <h6 class="m-0 p-0">{{ message }}</h6>
  </div>
  <div class="modal-footer">
    <button class="btn btn-dv m-r-10" (click)="modal.close('confirmed')">
      <i class="fa fa-check"></i>
      {{'COMMON.OK' | translate}}
    </button>
    <button class="btn btn-dv btn-clean" (click)="modal.close()">
      <i class="fa fa-times"></i>
      {{'COMMON.CLOSE' | translate}}
    </button>
  </div>
</ng-template>



// WEBPACK FOOTER //
// /opt/app/src/app/features/download-log/download-log.component.html